import React from 'react';
import { TailSpin } from 'react-loader-spinner';

import i18n from '../../utils/i18n';
const LoadingIndicator = () => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div>
        <p className='SFTitleBlue' style={{ margin: '32px auto' }}>
          {i18n.t('general.loading')}
        </p>
      </div>
      <TailSpin color='#336198' height='50' width='50' />
    </div>
  );
};
export default LoadingIndicator;
